import { render, staticRenderFns } from "./UserVerification.vue?vue&type=template&id=3a3b32b4&scoped=true"
import script from "./UserVerification.vue?vue&type=script&lang=js"
export * from "./UserVerification.vue?vue&type=script&lang=js"
import style0 from "./UserVerification.vue?vue&type=style&index=0&id=3a3b32b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b32b4",
  null
  
)

export default component.exports